import { Paragraph, Heading } from '@hungryroot/ramen';
import { SectionList } from '../SectionList/SectionList';
import { statePrivacySections } from './data';

import styles from './StatePrivacy.module.css';

interface Props {
  testid?: string;
}

export function StatePrivacy(props: Props) {
  const { testid } = props;
  return (
    <div className={styles.container} data-testid={testid}>
      <div className={styles.heading}>
        <Heading variant="H2" className={styles.title}>
          US State Privacy Law Notice
        </Heading>
        <Paragraph>Effective Date: April 4th, 2024</Paragraph>
      </div>
      <div>
        <Heading variant="H5" className={styles['margin-bottom']}>
          This State Law Privacy Notice is included in our Privacy Policy and
          applies to you only to the extent that you are a resident of
          California, Colorado, or Virginia.
        </Heading>
        <Paragraph className={styles['margin-bottom']}>
          This U.S. state law privacy notice (“State Law Privacy Notice”)
          relates to Hungryroot’s processing of personal information and your
          rights under the California Consumer Privacy Act, including as amended
          by the California Privacy Rights Act (the “CCPA”), the Colorado
          Privacy Act, and the Virginia Consumer Data Protection Act
          (collectively, the “State Privacy Laws”). Any capitalized terms not
          defined herein shall have the meanings ascribed to them in our Privacy
          Policy or, if not defined therein, the State Privacy Laws. Where the
          State Privacy Laws use terms similar to the terms used herein (e.g.,
          “personal data” instead of “personal information”), the term used
          herein shall also have the meaning under those laws. To the extent of
          any conflict between this State Law Privacy Notice and our Privacy
          Policy, this State Privacy Law Notice shall control only with respect
          to Consumers.
        </Paragraph>
        <Paragraph className={styles['margin-bottom']}>
          For additional information (or if you are not a resident of
          California, Colorado, or Virginia), please visit our general Privacy
          Policy available{' '}
          <a href="/privacy/" target="_blank" className={styles.link}>
            here
          </a>
          .
        </Paragraph>
      </div>
      <SectionList testid="state-privacy-list" data={statePrivacySections} />
    </div>
  );
}
